module.exports = __webpack_public_path__ + "fonts/50ac1699-f3d2-47b6-878f-67a368a17c41.afc80fd.woff";